import { render, staticRenderFns } from "./Boards.vue?vue&type=template&id=5a92cf9f&scoped=true&"
import script from "./Boards.vue?vue&type=script&lang=js&"
export * from "./Boards.vue?vue&type=script&lang=js&"
import style0 from "./Boards.vue?vue&type=style&index=0&id=5a92cf9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.8_cache-loader@4.1.0_webpack@4.46.0__css-loader@3.6.0_webpack@4.46.0__l_ab654a11f1d2b005dc7fd011f8cb0ddc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a92cf9f",
  null
  
)

export default component.exports